<script setup>
// ============================================================================
// BonBoZ: trang Thống kê > TỔNG ĐÀI — dựng theo đúng bố cục Pancake.
//
// BỐ CỤC:
//   1. Ba khung ngang: biểu đồ cuộc gọi theo thời gian · thẻ TỔNG CUỘC GỌI ·
//      thẻ THỜI GIAN ĐÀM THOẠI
//   2. Hai khung: tỉ lệ gọi thành công theo nhân viên · top 5 nhân viên
//   3. Hai bảng xếp chồng: theo NHÂN VIÊN rồi theo THỜI GIAN (không phải tab —
//      Pancake hiện cả hai cùng lúc)
//
// CHƯA NỐI KÊNH THOẠI NÀO nên mọi con số là 0 và hai bảng rỗng — đúng như chính
// Pancake của phòng khám đang hiện. Đây là truy vấn thật trên
// `content_type: voice_call`, không phải màn hình giả: ngày nối tổng đài là số
// tự lên. Bốn cột "thành công" và "thời lượng" cần bản ghi cuộc gọi, thứ bản
// Chatwoot này chưa có — chú giải từng cột nói rõ. Xem đầu
// `Bonboz::TongDaiBuilder`.
// ============================================================================
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import HieuSuatAPI from 'dashboard/api/bonboz/hieuSuat';
import { useAlert } from 'dashboard/composables';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import { dinhDangThoiLuong } from 'dashboard/helper/thoiLuong';
import { mauCss } from 'dashboard/helper/mauBieuDo';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import BieuDoTrang from './BieuDoTrang.vue';
import BieuDoTron from './BieuDoTron.vue';
import BangTongDai from './BangTongDai.vue';
import SectionCard from './SectionCard.vue';
import ReportHeader from '../components/ReportHeader.vue';
import OverviewReportFilters from '../components/OverviewReportFilters.vue';
import PhamVi from './PhamVi.vue';

const { t } = useI18n();
// Moi con so tren trang nay chi duoc dem tren nhung trang dang chon o bang
// dieu khien.
const { selectedInboxIds } = useSelectedPages();

const dangTai = ref(true);
const khoang = ref(null);
const gom = ref('ngay');
const soLieu = ref(null);

const tai = async () => {
  if (!khoang.value) return;
  dangTai.value = true;
  try {
    const { data } = await HieuSuatAPI.tongDai({
      since: khoang.value.from,
      until: khoang.value.to,
      inboxIds: selectedInboxIds.value,
      gom: gom.value,
    });
    soLieu.value = data;
  } catch {
    soLieu.value = null;
    useAlert(t('BONBOZ.TONG_DAI.LOI_TAI'));
  } finally {
    dangTai.value = false;
  }
};

const doiBoLoc = ({ from, to }) => {
  if (!from || !to) return;
  khoang.value = { from, to };
  tai();
};

const doiGom = kieu => {
  gom.value = kieu;
  tai();
};

// Lua chon trang nam trong `ui_settings` cua nguoi dung, tai ve SAU khi trang
// da mount — lan tai dau tien co the chay khi mang con rong (= tat ca).
watch(selectedInboxIds, tai);

// ------------------------------------------------------------------ số liệu
const tong = computed(
  () =>
    soLieu.value?.tong || {
      tong_goi: 0,
      goi_den: 0,
      goi_di: 0,
      goi_den_ok: 0,
      goi_di_ok: 0,
      tg_tong: 0,
      tg_den: 0,
      tg_di: 0,
      tg_den_tb: 0,
      tg_di_tb: 0,
    }
);
const chuoi = computed(() => soLieu.value?.chuoi || []);
const nhanVien = computed(() => soLieu.value?.nhan_vien || []);

const nhanTruc = computed(() =>
  chuoi.value.map(d =>
    gom.value === 'gio'
      ? `${String(d.moc).padStart(2, '0')}h`
      : new Date(d.moc * 1000).toLocaleDateString()
  )
);
const coGoi = computed(() => chuoi.value.some(d => d.goi_den || d.goi_di));

// Hai thẻ số lớn: cùng khuôn, chỉ khác đơn vị — một bên đếm cuộc, một bên đếm
// giây. Khai thành bảng để hai thẻ không thể lệch bố cục.
const theSo = computed(() => [
  {
    khoa: 'cuoc',
    lon: tong.value.tong_goi.toLocaleString(),
    nhan: 'BONBOZ.TONG_DAI.TONG_CUOC_GOI',
    dong: [
      { khoa: 'den', nhan: 'BONBOZ.TONG_DAI.GOI_DEN', gt: tong.value.goi_den },
      { khoa: 'di', nhan: 'BONBOZ.TONG_DAI.GOI_DI', gt: tong.value.goi_di },
      {
        khoa: 'den_ok',
        nhan: 'BONBOZ.TONG_DAI.GOI_DEN_OK',
        gt: tong.value.goi_den_ok,
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
      {
        khoa: 'di_ok',
        nhan: 'BONBOZ.TONG_DAI.GOI_DI_OK',
        gt: tong.value.goi_di_ok,
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
    ],
  },
  {
    khoa: 'thoi_gian',
    lon: dinhDangThoiLuong(tong.value.tg_tong),
    nhan: 'BONBOZ.TONG_DAI.TG_DAM_THOAI',
    gtLon: 'BONBOZ.TONG_DAI.G_CHUA_CO',
    dong: [
      {
        khoa: 'tg_den',
        nhan: 'BONBOZ.TONG_DAI.GOI_DEN',
        gt: dinhDangThoiLuong(tong.value.tg_den),
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
      {
        khoa: 'tg_di',
        nhan: 'BONBOZ.TONG_DAI.GOI_DI',
        gt: dinhDangThoiLuong(tong.value.tg_di),
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
      {
        khoa: 'tg_den_tb',
        nhan: 'BONBOZ.TONG_DAI.GOI_DEN_TB',
        gt: dinhDangThoiLuong(tong.value.tg_den_tb),
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
      {
        khoa: 'tg_di_tb',
        nhan: 'BONBOZ.TONG_DAI.GOI_DI_TB',
        gt: dinhDangThoiLuong(tong.value.tg_di_tb),
        gtCot: 'BONBOZ.TONG_DAI.G_CHUA_CO',
      },
    ],
  },
]);

// Tỉ lệ gọi thành công theo nhân viên: chỉ vẽ khi CÓ cuộc gọi thành công. Vẽ
// một vòng tròn rỗng cho 0/0 là bịa ra một phép chia không tồn tại.
const coThanhCong = computed(() =>
  nhanVien.value.some(n => (n.goi_den_ok ?? 0) + (n.goi_di_ok ?? 0) > 0)
);
const MAU_VONG = [
  '--bonboz-mo',
  '--bonboz-xong',
  '--bonboz-cho',
  '--bonboz-nguoi',
  '--bonboz-tre',
];
const miengVong = computed(() =>
  nhanVien.value.map((n, i) => ({
    tag: n.ten,
    so: (n.goi_den_ok ?? 0) + (n.goi_di_ok ?? 0),
    nen: mauCss(MAU_VONG[i % MAU_VONG.length]),
  }))
);

const topNhat = computed(() =>
  [...nhanVien.value]
    .map(n => ({ ...n, ok: (n.goi_den_ok ?? 0) + (n.goi_di_ok ?? 0) }))
    .filter(n => n.ok > 0)
    .sort((a, b) => b.ok - a.ok)
    .slice(0, 5)
);
const caoNhat = computed(() => Math.max(1, ...topNhat.value.map(n => n.ok)));

const TAB_GOM = [
  { khoa: 'ngay', nhan: 'BONBOZ.TRANG_TK.TAB_NGAY' },
  { khoa: 'gio', nhan: 'BONBOZ.TRANG_TK.TAB_GIO' },
];
</script>

<template>
  <ReportHeader
    :header-title="$t('BONBOZ.TONG_DAI.TIEU_DE')"
    :header-description="$t('BONBOZ.TONG_DAI.MO_TA')"
  />

  <div class="flex flex-col w-full gap-4 mx-auto max-w-6xl">
    <div class="flex flex-wrap items-center gap-3">
      <OverviewReportFilters
        class="flex-1 min-w-72"
        :disabled="dangTai"
        @filter-change="doiBoLoc"
      />
      <!-- Độ mịn của biểu đồ và của bảng theo thời gian. Pancake để ô này ngay
           cạnh bộ chọn ngày, cùng một hàng. -->
      <div class="flex p-0.5 rounded-lg shrink-0 bg-n-alpha-1">
        <button
          v-for="x in TAB_GOM"
          :key="x.khoa"
          type="button"
          class="px-3 py-1.5 text-sm rounded-md transition-colors"
          :class="
            gom === x.khoa
              ? 'bg-n-brand text-white font-medium'
              : 'text-n-slate-11 hover:text-n-slate-12'
          "
          @click="doiGom(x.khoa)"
        >
          {{ $t(x.nhan) }}
        </button>
      </div>
    </div>

    <PhamVi />

    <p class="px-3 py-2 m-0 text-xs rounded-lg text-n-amber-11 bg-n-amber-3">
      {{ $t('BONBOZ.TONG_DAI.CHUA_NOI') }}
    </p>

    <!-- ============ 1. BIỂU ĐỒ + HAI THẺ SỐ ============ -->
    <div class="grid gap-4 lg:grid-cols-2 lg:items-start">
      <SectionCard :title="$t('BONBOZ.TONG_DAI.BIEU_DO')">
        <div
          v-if="dangTai"
          class="rounded-lg h-52 bg-n-alpha-2 animate-pulse"
        />
        <p
          v-else-if="!coGoi"
          class="m-0 py-20 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.TONG_DAI.CHUA_CO_GOI') }}
        </p>
        <div v-else class="h-52">
          <BieuDoTrang
            :nhan="nhanTruc"
            :binh-luan="chuoi.map(d => d.goi_den)"
            :tin-nhan="chuoi.map(d => d.goi_di)"
            :ten-binh-luan="$t('BONBOZ.TONG_DAI.GOI_DEN')"
            :ten-tin-nhan="$t('BONBOZ.TONG_DAI.GOI_DI')"
          />
        </div>
      </SectionCard>

      <div class="grid gap-4 sm:grid-cols-2">
        <section
          v-for="the in theSo"
          :key="the.khoa"
          class="flex flex-col p-4 border rounded-xl border-n-weak bg-n-solid-2"
        >
          <span
            v-tooltip.top="the.gtLon ? $t(the.gtLon) : null"
            class="text-3xl font-light tabular-nums text-n-slate-11"
          >
            {{ the.lon }}
          </span>
          <span class="mt-1 text-xs tracking-wide uppercase text-n-slate-10">
            {{ $t(the.nhan) }}
          </span>
          <!-- Vạch ngang mảnh có chấm ở đầu mút, đúng như Pancake. Nó là hình
               trang trí chứ không mang số liệu, nên `aria-hidden`. -->
          <span
            class="relative block h-px mt-4 mb-3 bg-n-blue-6"
            aria-hidden="true"
          >
            <span
              class="absolute right-0 rounded-full -top-1 size-2 bg-n-blue-9"
            />
          </span>
          <ul class="flex flex-col gap-2 p-0 m-0 list-none">
            <li
              v-for="d in the.dong"
              :key="d.khoa"
              v-tooltip.top="d.gtCot ? $t(d.gtCot) : null"
              class="flex items-center justify-between gap-2 text-sm"
            >
              <span class="truncate text-n-slate-11">{{ $t(d.nhan) }}</span>
              <span class="tabular-nums text-n-teal-11">{{ d.gt }}</span>
            </li>
          </ul>
        </section>
      </div>
    </div>

    <!-- ============ 2. TỈ LỆ + TOP 5 ============ -->
    <div class="grid gap-4 lg:grid-cols-2 lg:items-start">
      <SectionCard :title="$t('BONBOZ.TONG_DAI.TI_LE')">
        <div
          v-if="dangTai"
          class="h-48 rounded-lg bg-n-alpha-2 animate-pulse"
        />
        <p
          v-else-if="!coThanhCong"
          class="m-0 py-16 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.TONG_DAI.CHUA_CO_GOI') }}
        </p>
        <div v-else class="relative mx-auto size-44">
          <div class="absolute inset-0">
            <BieuDoTron :dong="miengVong" />
          </div>
        </div>
      </SectionCard>

      <SectionCard :title="$t('BONBOZ.TONG_DAI.TOP_NHAN_VIEN')">
        <div
          v-if="dangTai"
          class="h-48 rounded-lg bg-n-alpha-2 animate-pulse"
        />
        <p
          v-else-if="!topNhat.length"
          class="m-0 py-16 text-sm text-center text-n-slate-11"
        >
          {{ $t('BONBOZ.TONG_DAI.CHUA_CO_GOI') }}
        </p>
        <ul v-else class="flex flex-col gap-3 p-0 m-0 list-none">
          <li v-for="n in topNhat" :key="n.id" class="flex items-center gap-2">
            <Avatar :src="n.anh" :name="n.ten" :size="28" rounded-full />
            <span class="w-24 text-sm truncate shrink-0 text-n-slate-12">
              {{ n.ten }}
            </span>
            <span class="flex items-center flex-1 gap-2 min-w-0">
              <span
                class="h-6 rounded bg-[rgb(var(--bonboz-mo)/0.18)]"
                :style="{ width: `${Math.max(4, (n.ok / caoNhat) * 100)}%` }"
              />
              <span class="text-xs tabular-nums text-n-slate-11">
                {{ n.ok }}
              </span>
            </span>
          </li>
        </ul>
      </SectionCard>
    </div>

    <!-- ============ 3. HAI BẢNG XẾP CHỒNG ============ -->
    <BangTongDai
      :dong="nhanVien"
      kieu="nhan_vien"
      :gom="gom"
      :dang-tai="dangTai"
    />
    <BangTongDai
      :dong="soLieu?.thoi_gian || []"
      kieu="thoi_gian"
      :gom="gom"
      :dang-tai="dangTai"
    />
  </div>
</template>
